const appConfig = {
  // Nombre de la empresa, usado en títulos y textos
  companyName: "Nona Minda",
  companyDescription: "Tienda online de productos para el hogar y la vida diaria",

  // Controla si se muestra el filtro de precios en la tienda
  // true: para mostrarlo, false: para ocultarlo
  showPriceFilter: false,

  // URL base de la API de productos
  apiUrl: "https://api.nonaminda.com/api",

  // URL base para las imágenes de los productos
  imageBaseUrl: "https://delplastic.com.ar/delplastic/Productos",

  // Duración en minutos de la caché de productos
  productCacheMinutes: 5,

  // Aquí puedes agregar otras configuraciones globales en el futuro
};

export default appConfig;